/* 🤖 this file was generated by svg-to-ts */
export const emperorIconInterfaceAlertDiamond: {
  name: 'interface_alert_diamond';
  data: string;
} = {
  name: 'interface_alert_diamond',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M12 22c-.26 0-.52-.1-.71-.3l-9-9c-.391-.391-.391-1.03 0-1.42l9-9c.391-.391 1.02-.391 1.41 0l9 9c.39.39.39 1.02 0 1.41l-9 9c-.2.19-.46.29-.71.29ZM4.414 12L12 19.58l7.58-7.59L11.99 4.4 4.4 11.99Z"/><path d="M11 8h2v6h-2Z"/><path d="M12 14.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 1 0 0-2.5Z"/></g></svg>`
};
